import {collapse, toggle} from 'lib/animation/collapsible';

export default function init_collapsible() {
    document.querySelectorAll('.collapsible-trigger').forEach((trigger: HTMLElement) => {
        const target = document.querySelector(trigger.dataset.target) as HTMLElement;

        if (target.classList.contains('collapsed')) {
            collapse(target, {
                duration: 0
            });
        }

        trigger.classList.toggle('collapsed', target.classList.contains('collapsed'));

        trigger.addEventListener('click', () => {
            toggle(target);
            target.classList.toggle('collapsed');
            trigger.classList.toggle('collapsed', target.classList.contains('collapsed'));
        });
    });
}
